import { ArticleCardData } from "@baseComponents/ArticleCard";

import { metadata as articleCardPortEn } from "./port_en.mdx";
import { metadata as articleCardPortPl } from "./port_pl.mdx";

export const articleCardPortLocalized = {
  en: articleCardPortEn as ArticleCardData,
  pl: articleCardPortPl as ArticleCardData,
};
